module.exports = __webpack_public_path__ + "media/dashboard/assets/images/Mask-721a0a2861577686bbdbee91e100b01a.png";